module.exports = __webpack_public_path__ + "img/denuncia.302e7b3d.png";